import React from 'react';
import {Platform, StyleProp, View, ViewStyle} from 'react-native';
import {PageContainer} from '../../../PageContainer';
import {styles} from './styles';

interface DetailAssuranceContainerProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}
export const AssuranceVoyageContainer = ({
  children,
  style,
}: DetailAssuranceContainerProps) => {
  return Platform.OS === 'web' ? (
    <PageContainer>{children}</PageContainer>
  ) : (
    <View style={style}>{children}</View>
  );
};

interface BoxShadowedProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}
export const BoxShadowed = ({children, style}: BoxShadowedProps) => {
  return <View style={[styles.BoxShadowedContainer, style]}>{children}</View>;
};
